import { Suspense } from 'react';
import dynamic from 'next/dynamic';

import { SectionType } from 'src/constants/enums';
import { Block, Section } from 'src/__generated__/graphqlTypes';
/*  Keep direct imports for components not in the specified list */
import AboutHeroImage from 'components/Sections/AboutHeroImage';
import SignIntroContainer from 'components/Sections/HoroscopesSignsSignIntro';
import HoroscopesAndPredictions from 'components/Sections/HoroscopesSignsHoroscopesAndPredictions';
import AllAboutSigns from 'components/Sections/HoroscopesSignsAllAboutSigns';
import MysteryDirections from 'components/Sections/HoroscopesSignsMysteryDirections';
import PsychicsSetMediumSizeImages from 'components/Sections/PsychicsSetMediumSizeImagesClone';
import OrangeAlert from 'components/Sections/OrangeAlert';
import NcOfferPackages from 'components/Sections/NcOfferPackages';
import ExpandableItemsList from 'components/Sections/ExpandableItemsList';
import CtaFlatBanner from 'components/Sections/CtaFlatBanner';
import CircleImageDescriptionButtonClone from 'components/Sections/CircleImageDescriptionButtonClone';
import MysteryLinksSet from 'components/Sections/MysteryLinksSet';
import BreadCrumbs from 'components/Sections/BreadCrumbs';
import { OrangeAlertBig } from 'src/widgets/OrangeAlertBig';
import { TextAndSideAsset } from 'src/widgets/TextAndSideAsset';
import InlineHtml from 'components/Sections/InlineHtml';
import ExponeaPsychicsList from 'components/Sections/ExponeaPsychicsList';
import { PredefinedReviews } from 'src/widgets/PredefinedReviews';
import { ContentWithSubBlocks } from 'src/widgets/ContentWithSubBlocks';
import { DualColured } from 'src/widgets/DualColuredText';
import LocalLoader from 'src/shared/ui/LocalLoader/LocalLoader';

import Divider from './Divider';
import RelatedBlogPosts from './RelatedBlogPosts';

const AboutLeftImage = dynamic(() => import('components/Sections/AboutLeftImage').then((mod) => mod.default), { ssr: true });
const CircleImageDescriptionButton = dynamic(() => import('components/Sections/CircleImageDescriptionButton').then((mod) => mod.default), { ssr: true });
const AboutOrangeAlert = dynamic(() => import('components/Sections/AboutOrangeAlert').then((mod) => mod.default), { ssr: true });
const AboutNcOfferPackages = dynamic(() => import('components/Sections/AboutNcOfferPackages').then((mod) => mod.default), { ssr: true });
const AboutPsychicsSetMediumSizeImages = dynamic(() => import('components/Sections/PsychicsSetMediumSizeImages').then((mod) => mod.default), { ssr: true });
const AboutLeftVideo = dynamic(() => import('components/Sections/AboutLeftVideo').then((mod) => mod.default), { ssr: true });
const ContactUsGetInTouch = dynamic(() => import('components/Sections/ContactUsGetInTouch').then((mod) => mod.default), { ssr: true });
const ContactUsHelpCenter = dynamic(() => import('components/Sections/ContactUsHelpCenter').then((mod) => mod.default), { ssr: true });
const FixedBanner = dynamic(() => import('components/Sections/FixedBanner').then((mod) => mod.default), { ssr: true });
const GridHeroBanner = dynamic(() => import('components/Sections/GridHeroBanner').then((mod) => mod.default), { ssr: true });
const PsychicsTiersHardcoded = dynamic(() => import('components/Sections/PsychicsTiersHardcoded').then((mod) => mod.default), { ssr: true });
const ExponeaPsychicProfile = dynamic(() => import('components/Sections/ExponeaPsychicProfile').then((mod) => mod.default), { ssr: true });
const PlainItemsWithDescription = dynamic(() => import('src/widgets/PlainItemsWithDescription').then((mod) => mod.default), { ssr: true });
const TemplateHtmlPsychics = dynamic(() => import('src/widgets/TemplateHtmlPsychics').then((mod) => mod.TemplateHtmlPsychics), { ssr: true });
const CustomerTestimonials = dynamic(() => import('src/widgets/CustomersTestimonials').then((mod) => mod.CustomerTestimonials), { ssr: true });
const OptionalTrustpilot = dynamic(() => import('src/widgets/OptionalTrustpilot').then((mod) => mod.OptionalTrustpilot), { ssr: true });
const HoroSignShortInfo = dynamic(() => import('src/widgets/HoroSignShortInfo').then((mod) => mod.HoroSignShortInfo), { ssr: true });
const OffersList = dynamic(() => import('src/widgets/OffersListCarousel').then((mod) => mod.OffersList), { ssr: true });
const PriceCardsWithKarma = dynamic(() => import('src/widgets/PriceCardsWithKarma').then((mod) => mod.PriceCardsWithKarma), { ssr: true });
const FlexColumns = dynamic(() => import('src/widgets/FlexColumns').then((mod) => mod.FlexColumns), { ssr: true });
const GreetAndPsychicNotification = dynamic(() => import('src/widgets/GreetAndPsychicNotification').then((mod) => mod.GreetAndPsychicNotification), { ssr: true });
const PsychicsSetSwitchApi = dynamic(() => import('src/widgets/PsychicsSetSwitchApi').then((mod) => mod.PsychicsSetSwitchApi), { ssr: true });
const GreetAndOffer = dynamic(() => import('src/widgets/GreetAndOffers').then((mod) => mod.GreetAndOffer), { ssr: true });
const SectionsCombiner = dynamic(() => import('src/widgets/SectionsCombiner').then((mod) => mod.SectionsCombiner), { ssr: true });
const CustomersTestimonialsList = dynamic(() => import('src/widgets/CustomersTestimonialsList').then((mod) => mod.CustomersTestimonialsList), { ssr: true });
const AppointmentCalendar = dynamic(() => import('src/widgets/AppointmentCalendar').then((mod) => mod.AppointmentCalendar), { ssr: true });
const SimilarPsychics = dynamic(() => import('src/widgets/SimilarPsychics').then((mod) => mod.SimilarPsychics), { ssr: true });
const PsychicBioInformation = dynamic(() => import('src/widgets/PsychicBioInformation').then((mod) => mod.PsychicBioInformation), { ssr: true });
const CustomerPendingFeedback = dynamic(() => import('src/widgets/CustomerPendingFeedback').then((mod) => mod.CustomerPendingFeedback), { ssr: true });
const TopicsLinks = dynamic(() => import('src/widgets/TopicsLinks').then((mod) => mod.TopicsLinks), { ssr: true });
const PriceBasedPackages = dynamic(() => import('src/widgets/PriceBasedPackages').then((mod) => mod.PriceBasedPackages), { ssr: true });
const CustomizableMobileSlider = dynamic(() => import('src/widgets/CustomizableMobileSlider').then((mod) => mod.CustomizableMobileSlider), { ssr: true });
const DynamicModalWithStore = dynamic(() => import('src/widgets/DynamicModalWithStore').then((mod) => mod.DynamicModalWithStore), { ssr: true });

export const getAppropriateSection = (section: Section, keyPart?: number) => {
  if (!section) {
    return null;
  }

  const {
    type,
    blocksCollection,
    backgroundColor,
    entryName,
    data,
  } = section;
  const blocks = blocksCollection?.items as Array<Block> | undefined;

  if (!blocks) {
    return null;
  }

  const renderLazySection = (Component: any) => (
    <Suspense key={`${entryName}-${keyPart || 0}`} fallback={<LocalLoader />}>
      <Component
        blocks={blocks}
        extraData={data}
        bgColor={backgroundColor!}
      />
    </Suspense>
  );

  const renderDirectSection = (Component: any) => (
    <Component
      key={`${entryName}-${keyPart || 0}`}
      blocks={blocks}
      extraData={data}
      bgColor={backgroundColor!}
    />
  );

  switch (type) {
    case SectionType.ABOUT_HERO_IMAGE: {
      return renderDirectSection(AboutHeroImage);
    }
    case SectionType.ABOUT_LEFT_IMAGE: {
      return renderLazySection(AboutLeftImage);
    }
    case SectionType.ABOUT_LEFT_VIDEO: {
      return renderLazySection(AboutLeftVideo);
    }
    case SectionType.ABOUT_NC_OFFER_PACKAGES: {
      return renderLazySection(AboutNcOfferPackages);
    }
    case SectionType.ABOUT_ORANGE_ALERT: {
      return renderLazySection(AboutOrangeAlert);
    }
    case SectionType.ABOUT_PSYCHICS_SET_MEDIUM_SIZE_IMAGES: {
      return renderLazySection(AboutPsychicsSetMediumSizeImages);
    }
    case SectionType.CIRCLE_IMAGE_DESCRIPTION_BUTTON: {
      return renderLazySection(CircleImageDescriptionButton);
    }
    case SectionType.HOROSCOPES_SIGNS_SIGN_INTRO: {
      return renderDirectSection(SignIntroContainer);
    }
    case SectionType.HOROSCOPES_SIGNS_HOROSCOPES_AND_PREDICTIONS: {
      return renderDirectSection(HoroscopesAndPredictions);
    }
    case SectionType.HOROSCOPES_SIGNS_ALL_ABOUT_SIGNS: {
      return renderDirectSection(AllAboutSigns);
    }
    case SectionType.HOROSCOPES_SIGNS_MYSTERY_DIRECTIONS: {
      return renderDirectSection(MysteryDirections);
    }
    case SectionType.CONTACT_US_HELP_CENTER: {
      return renderLazySection(ContactUsHelpCenter);
    }
    case SectionType.CONTACT_US_GET_IN_TOUCH: {
      return renderLazySection(ContactUsGetInTouch);
    }
    case SectionType.CUSTOMERS_TESTIMONIALS_LIST: {
      return renderLazySection(CustomersTestimonialsList);
    }
    case SectionType.PSYCHICS_SET_MEDIUM_SIZE_IMAGES_CLONE: {
      return renderDirectSection(PsychicsSetMediumSizeImages);
    }
    case SectionType.CIRCLE_IMAGE_DESCRIPTION_BUTTON_CLONE: {
      return renderDirectSection(CircleImageDescriptionButtonClone);
    }
    case SectionType.ORANGE_ALERT_CLONE: {
      return renderDirectSection(OrangeAlert);
    }
    case SectionType.NC_OFFER_PACKAGES_CLONE: {
      return renderDirectSection(NcOfferPackages);
    }
    case SectionType.MYSTERY_LINKS_SET: {
      return renderDirectSection(MysteryLinksSet);
    }
    case SectionType.EXPANDABLE_ITEMS_LIST: {
      return renderDirectSection(ExpandableItemsList);
    }
    case SectionType.BREAD_CRUMBS: {
      return renderDirectSection(BreadCrumbs);
    }
    case SectionType.CTA_FLAT_BANNER: {
      return renderDirectSection(CtaFlatBanner);
    }
    case SectionType.ORANGE_ALERT_BIG: {
      return renderDirectSection(OrangeAlertBig);
    }
    case SectionType.CONTENT_DIVIDER: {
      return renderDirectSection(Divider);
    }
    case SectionType.RELATED_BLOG_POST: {
      return renderDirectSection(RelatedBlogPosts);
    }
    case SectionType.FIXED_BANNER: {
      return renderLazySection(FixedBanner);
    }
    case SectionType.INLINE_HTML: {
      return renderDirectSection(InlineHtml);
    }
    case SectionType.EXPONEA_PSYCHICS_LIST: {
      return renderDirectSection(ExponeaPsychicsList);
    }
    case SectionType.EXPONEA_PSYCHIC_PROFILE: {
      return renderLazySection(ExponeaPsychicProfile);
    }
    case SectionType.PSYCHICS_TIERS_HARDCODED: {
      return renderLazySection(PsychicsTiersHardcoded);
    }
    case SectionType.GRID_HERO_BANNER: {
      return renderLazySection(GridHeroBanner);
    }
    case SectionType.PLAIN_ITEMS_WITH_DESCRIPTION: {
      return renderLazySection(PlainItemsWithDescription);
    }
    case SectionType.TEMPLATE_HTML_PSYCHICS: {
      return renderLazySection(TemplateHtmlPsychics);
    }
    case SectionType.CUSTOMERS_TESTIMONIALS: {
      return renderLazySection(CustomerTestimonials);
    }
    case SectionType.OPTIONAL_TRUSTPILOT: {
      return renderLazySection(OptionalTrustpilot);
    }
    case SectionType.EC_GREET_AND_PSYCHIC_NOTIFICATIONS: {
      return renderLazySection(GreetAndPsychicNotification);
    }
    case SectionType.FLEX_COLUMNS: {
      return renderLazySection(FlexColumns);
    }
    case SectionType.SECTIONS_COMBINER: {
      return renderLazySection(SectionsCombiner);
    }
    case SectionType.EC_OFFERS_LIST: {
      return renderLazySection(OffersList);
    }
    case SectionType.EC_HORO_SIGH_SHORT_INFO: {
      return renderLazySection(HoroSignShortInfo);
    }
    case SectionType.EC_PRICE_CARDS_WITH_KARMA: {
      return renderLazySection(PriceCardsWithKarma);
    }
    case SectionType.EC_GREET_AND_OFFERS: {
      return renderLazySection(GreetAndOffer);
    }
    case SectionType.PSYCHICS_SET_SWITCH_API: {
      return renderLazySection(PsychicsSetSwitchApi);
    }
    case SectionType.SIMILAR_PSYCHICS: {
      return renderLazySection(SimilarPsychics);
    }
    case SectionType.APPOINTMENT_CALENDAR: {
      return renderLazySection(AppointmentCalendar);
    }
    case SectionType.PSYCHIC_BIO_INFORMATION: {
      return renderLazySection(PsychicBioInformation);
    }
    case SectionType.CUSTOMER_PENDING_FEEDBACK: {
      return renderLazySection(CustomerPendingFeedback);
    }
    case SectionType.DUAL_COLORED_TEXT: {
      return renderDirectSection(DualColured);
    }
    case SectionType.PREDEFINED_REVIEWS: {
      return renderLazySection(PredefinedReviews);
    }
    case SectionType.CONTENT_WITH_SUB_BLOCKS: {
      return renderLazySection(ContentWithSubBlocks);
    }
    case SectionType.TEXT_AND_SIDE_ASSET: {
      return renderDirectSection(TextAndSideAsset);
    }
    case SectionType.PRICE_BASED_PACKAGES: {
      return renderLazySection(PriceBasedPackages);
    }
    case SectionType.TOPICS_LINKS: {
      return renderLazySection(TopicsLinks);
    }
    case SectionType.CUSTOMIZABLE_MOBILE_SLIDER: {
      return renderLazySection(CustomizableMobileSlider);
    }
    case SectionType.DYNAMIC_MODAL_WITH_STORE: {
      return renderLazySection(DynamicModalWithStore);
    }
    default: {
      return null;
    }
  }
};

export const renderReactComponentsByType = (
  content: Array<Section>,
) => content?.map((section, i) => getAppropriateSection(section, i));
